import { useCallback } from 'react';
import { useSocketEvent } from '@connect-x-app/hybrid-data-access';
import { RoomMuteEvent, RoomScheduleEvent } from '@connect-x-app/shared-domain-models';

import { useFlightRoomStore, useSocketStore } from '../../stores';

export const useFlightRoomSocketEvents = () => {
  const { flightRooms, updatePartialFlightRoom } = useFlightRoomStore();
  const { socket } = useSocketStore();

  const handleMuteUpdate = useCallback(
    (roomMute: RoomMuteEvent) => {
      const room = Array.from(flightRooms.values()).find(f => f.externalId === roomMute.flightRoomId);

      if (room) {
        updatePartialFlightRoom(room.id, {
          muted: roomMute.muted,
          mutedUntilDurationBeforeDeparture: roomMute.mutedUntilDurationBeforeDeparture,
        });
      }
    },
    [flightRooms, updatePartialFlightRoom],
  );

  const handleScheduleUpdate = useCallback(
    (roomSchedule: RoomScheduleEvent) => {
      const room = flightRooms.get(roomSchedule.chatroomId);

      if (room) {
        updatePartialFlightRoom(roomSchedule.chatroomId, { schedule: roomSchedule.schedule });
      }
    },
    [flightRooms, updatePartialFlightRoom],
  );

  useSocketEvent(socket, 'room.mute', handleMuteUpdate);
  useSocketEvent(socket, 'room.schedule', handleScheduleUpdate);
};
